import React, { useEffect } from "react";

const Offers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <div className="flex justify-center py-10 lg:py-20 bg-page-header-bg bg-brand-100 w-full bg-cover bg-no-repeat bg-bottom bg-page-header ">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-center text-black">
              Offers
            </h2>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-screen-2xl px-4 py-10 lg:py-20 sm:px-10">
        <div className="rounded-lg border border-dashed border-gray-300 bg-white px-6 py-16 text-center">
          <h3 className="text-lg font-semibold text-gray-900">No offers available</h3>
          <p className="mt-2 text-sm text-gray-500">
            Check back later for wholesale deals and coupon codes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Offers;
